import * as vm from 'generated/api/vm.api';

type GetRealPropertySellApplicationList = vm.paths['/open-api/realProperty/getRealPropertyForWebClientApplication'];
export type GetRealPropertySellApplicationListParams = GetRealPropertySellApplicationList['post']['parameters']['body']['dto'];
export type RealPropertySellApplicationResp = GetRealPropertySellApplicationList['post']['responses']['200']['schema'];
export type RealPropertySellApplicationList = GetRealPropertySellApplicationList['post']['responses']['200']['schema']['data']['data'];

type GetTopRealProperty = vm.paths['/open-api/realProperty/getTopRealProperty'];
export type GetTopRealPropertyParams = GetTopRealProperty['post']['parameters']['body']['criteria'];
export type GetTopRealPropertyResp = GetTopRealProperty['post']['responses']['200']['schema'];
export type GetTopRealPropertyList = GetTopRealProperty['post']['responses']['200']['schema'];

type GetCountRealProperty = vm.paths['/open-api/realProperty/getCountRealProperty'];
export type GetCountRealPropertyParams = GetCountRealProperty['post']['parameters']['body']['filterDto'];
export type GetCountRealPropertyResp = GetCountRealProperty['post']['responses']['200']['schema'];
export type GetCountRealPropertyList = GetCountRealProperty['post']['responses']['200']['schema'];
